import { render, staticRenderFns } from "./pubgoodsucceed.vue?vue&type=template&id=7333616d&scoped=true"
import script from "./pubgoodsucceed.vue?vue&type=script&lang=js"
export * from "./pubgoodsucceed.vue?vue&type=script&lang=js"
import style0 from "./pubgoodsucceed.vue?vue&type=style&index=0&id=7333616d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7333616d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7333616d')) {
      api.createRecord('7333616d', component.options)
    } else {
      api.reload('7333616d', component.options)
    }
    module.hot.accept("./pubgoodsucceed.vue?vue&type=template&id=7333616d&scoped=true", function () {
      api.rerender('7333616d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/pubgoodsucceed.vue"
export default component.exports